import * as remote from './remotes';
import * as stub from './stubs';
import { endpoints } from './endpoints';
import {
  GetNewMembershipInfo,
  ValidateNationalToken,
  JoinInitInfo,
  SubmitNewJoinFormData,
  JoinConfirmation,
  CheckMembershipStatus,
  GetPaymentManifest,
  RegisterAccount,
  GetNewBusinessCost,
  GetMembershipContent,
  EncryptAnalytics,
  GetPartnerEnrollmentStatus,
  GetPartnerEligibility,
  PartnerEnrollment,
} from './contracts';

type Sources = {
  getNewMembershipInfo: GetNewMembershipInfo;
  validateNationalToken: ValidateNationalToken;
  getJoinInitInfo: JoinInitInfo;
  submitNewJoinFormData: SubmitNewJoinFormData;
  getConfirmation: JoinConfirmation;
  getPaymentManifest: GetPaymentManifest;
  checkMembershipStatus: CheckMembershipStatus;
  registerAccount: RegisterAccount;
  getNewBusinessCost: GetNewBusinessCost;
  getMembershipContent: GetMembershipContent;
  encryptAnalytics: EncryptAnalytics;
  getPartnerEnrollmentStatus: GetPartnerEnrollmentStatus;
  getPartnerEligibility: GetPartnerEligibility;
  postPartnerEnrollment: PartnerEnrollment;
};

const stubs: Sources = {
  getNewMembershipInfo: stub.GetNewMembershipInfoStub,
  validateNationalToken: stub.ValidateNationalTokenStub,
  getJoinInitInfo: stub.JoinInitInfoStub,
  submitNewJoinFormData: stub.ValidateMemberStub,
  getConfirmation: stub.JoinConfirmationStub,
  checkMembershipStatus: stub.CheckMembershipStatusStub(), // Requires scoped variables to function correctly
  getPaymentManifest: stub.GetPaymentManifestStub,
  registerAccount: stub.RegisterAccountStub,
  getNewBusinessCost: stub.GetNewBusinessCostStub,
  getMembershipContent: stub.GetMembershipContentStub,
  encryptAnalytics: stub.EncryptAnalyticsStub,
  getPartnerEnrollmentStatus: stub.GetPartnerEnrollmentStatusStub,
  getPartnerEligibility: stub.GetPartnerEligibilityStub,
  postPartnerEnrollment: stub.PartnerEnrollmentStub,
};

const remotes: Sources = {
  getNewMembershipInfo: remote.GetNewMembershipInfoApi(endpoints.getNewMembershipInfo),
  getJoinInitInfo: remote.JoinInitInfoApi(endpoints.getJoinInitInfo),
  validateNationalToken: remote.ValidateNationalTokenApi(endpoints.validateNationalToken),
  submitNewJoinFormData: remote.SubmitNewJoinFormDataApi(endpoints.submitNewJoinFormData),
  getConfirmation: remote.JoinConfirmationApi(endpoints.getConfirmation),
  getPaymentManifest: remote.GetPaymentManifestApi(endpoints.getPaymentManifest),
  checkMembershipStatus: remote.CheckMembershipStatusApi(endpoints.checkMembershipStatus),
  registerAccount: remote.RegisterAccountApi(endpoints.registerAccount),
  getNewBusinessCost: remote.GetNewBusinessCostApi(endpoints.getNewBusinessCost),
  getMembershipContent: remote.GetMembershipContentApi(endpoints.getMembershipContent),
  encryptAnalytics: remote.EncryptAnalyticsApi(endpoints.encryptAnalytics),
  getPartnerEnrollmentStatus: remote.GetPartnerEnrollmentStatusApi(endpoints.getPartnerEnrollmentStatus),
  getPartnerEligibility: remote.GetPartnerEligibilityApi(endpoints.getPartnerEligibility),
  postPartnerEnrollment: remote.PartnerEnrollmentApi(endpoints.postPartnerEnrollment),
};

export const sources =
  process.env.NODE_ENV === 'production' || process.env.REACT_APP_SOURCES === 'remote' ? remotes : stubs;
